import { useMemo } from 'react';

import styles from './styles.module.css';
import WsConnected from '@/assets/icons/ws-connected.svg?react';
import WsDisconnected from '@/assets/icons/ws-disconnected.svg?react';
import { useWebSocket } from '@/context/WebSocketContext';
import { getLastUpdateDisplayTime } from '@/utils/formatLastUpdate';

interface WebSocketIndicatorProps {
  turbineStatus?: {
    powerStatus?: string;
    sentAt?: string;
    timezone?: string;
  };
}

const WebSocketIndicator = (
  { turbineStatus }: WebSocketIndicatorProps = {} as WebSocketIndicatorProps
) => {
  const { lastUpdateTime, readyState, socketData } = useWebSocket();

  const displayTime = useMemo(
    () =>
      getLastUpdateDisplayTime({
        lastUpdateTime,
        hasWebsocketData: Boolean(socketData),
        sentAt: turbineStatus?.sentAt,
        timezone: turbineStatus?.timezone,
        powerStatus: turbineStatus?.powerStatus
      }),
    [turbineStatus, lastUpdateTime, socketData]
  );

  const wsIcon =
    readyState === 1 ? (
      <WsConnected className={styles.wsConnectedIconWithStroke} />
    ) : (
      <WsDisconnected className={styles.wsDisconnectedIconWithStroke} />
    );

  return (
    <div className={styles.WSContainer}>
      <p className={styles.lastUpdateText}>Last Update</p>
      <p className={styles.lastUpdateValue}>{displayTime}</p>
      <span className={styles.wsIcon}>{wsIcon}</span>
    </div>
  );
};

export default WebSocketIndicator;
